const headingTags = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5',
  6: 'h6',
} as const;

type Level = keyof typeof headingTags;
type TagName = (typeof headingTags)[Level];

interface Base extends React.PropsWithChildren {
  id?: string;
  level: Level;
  className?: string;
}

// Create separate types for each case
interface PropsWithChildren extends Omit<Base, 'html'> {
  children?: React.ReactNode;
  html?: never;
}

interface PropsWithHTML extends Omit<Base, 'children'> {
  html?: string;
  children?: never;
}

// Export a union type that allows one or the other
export type IProps = PropsWithChildren | PropsWithHTML;

export type { Level, TagName };
export { headingTags };
